import Styles from "./UnpackCard.module.scss"
import React from "react";
import P1 from "../../typography/P1";
import P3 from "../../typography/P3";
import PuzzlesIcon from "../../../icons/PuzzlesIcon";
import { L } from "../../../l10n/L10n";

export const UnpackPuzzleCard = (
	{
		img,
		name,
		author,
		amount,
	}: {
		img: string,
		name: string,
		author: string,
		amount: number,
	}
) => (
	<div className={Styles.card}>
		<div className={Styles.img}><img src={img} alt={name}/></div>
		<div className={Styles.info}>
			<div className={Styles.text}>
				<P1 className={Styles.name} isBold>{name}</P1>
				<P3>{author}</P3>
			</div>
			<div className={Styles.amount}>
				<PuzzlesIcon color={"#444244"}/>
				{L.unpack.new_puzzels.replace('$amount$', amount.toString() ?? "")}
			</div>
		</div>
	</div>
)